<template>
  <div class="addPerson__wrap" v-show="visible">
    <el-header class="shadow page-header__wrap">
      <div class="flex">
        <div class="backBtn" @click="handleReturn">
          <el-image
            class="back-img"
            :src="require('@/assets/img/back.png')"
          ></el-image>
          <span>返回</span>
        </div>
        <div class="title">
          <span class="site">当前位置：</span>
          {{ $route.meta.title }}
          <span> > </span>
          查看详情({{ group_name }})
        </div>
      </div>
    </el-header>

    <div class="main-view">
      <div class="section shadow filter__wrap">
        <el-form
          ref="elFormDom"
          inline
          :model="table.params"
          :size="subUnitSize"
        >
          <el-form-item label="商品名称" prop="merchant_id">
            <el-input
              size="mini"
              v-model.trim="table.params.goods_name"
              placeholder="请输入商品名称"
              clearable
              @keydown.enter.native="onSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="下单分类" prop="order_cate_id">
            <el-cascader
              v-model="table.params.order_cate_id"
              filterable
              placeholder="请选择"
              id="order_cate_arr"
              @change="changeOrderCateId"
              @focus="getOrderCateSel"
              :options="orderCateArr"
              :props="{
                children: 'child',
                label: 'name',
                value: 'id',
                checkStrictly: true,
              }"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="定价方式" prop="price_type">
            <el-select
              v-model="table.params.price_type"
              filterable
              placeholder="请选择定价方式"
              id="group_id"
              clearable
              @change="onSearch"
            >
              <el-option label="线下询价" :value="1"> </el-option>
              <el-option label="采购价" :value="2"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSearch"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh-right" @click="reset2"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
        <div class="btnAdd">
          <el-button
            :size="subUnitSize"
            type="primary"
            icon="el-icon-plus"
            @click="showEdit(1)"
            >添加报价</el-button
          >
        </div>
      </div>

      <div class="mainBox" v-loading="table.loading">
        <el-table :data="table.data" border style="width: 100%" height="100%">
          <el-table-column type="index" width="80" label="序号">
          </el-table-column>
          <el-table-column prop="pics" label="图片" width="120">
            <template v-slot="{ row }">
              <el-image
                v-for="(item, index) in row.pics"
                :key="index"
                style="width: 60px; height: 60px"
                :src="item"
                fit="cover"
                :preview-src-list="row.pics"
                v-show="index == 0"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="code" label="名称编码">
            <template v-slot="{ row }">
              <div>{{ row.goods_name }}</div>
              {{ row.code }}
            </template>
          </el-table-column>
          <el-table-column prop="unit_name" label="单位"> </el-table-column>
          <el-table-column prop="name" label="规格"> </el-table-column>
          <el-table-column prop="order_cate_name" label="下单分类">
            <template v-slot="{ row }">
              {{ row.order_cate_name
              }}{{ row.order_tow_name ? `/${row.order_tow_name}` : "" }}
            </template>
          </el-table-column>
          <el-table-column prop="cate_name" label="商品分类"> </el-table-column>
          <el-table-column prop="price_type" label="定价方式">
            <template v-slot="{ row }">
              {{ { 1: "线下询价", 2: "采购价" }[row.price_type] }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="参考价"> </el-table-column>
          <el-table-column prop="rate" label="折扣率"> </el-table-column>
          <el-table-column prop="sell_amount" label="售价"> </el-table-column>
          <el-table-column prop="update_time" label="更新时间" width="160">
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="120">
            <template v-slot="{ row }">
              <el-button type="text" @click="showEdit(2, row)">修改</el-button>
              <el-button type="text" @click="del(row)">删除报价</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination__wrap">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="table.params.page"
          :page-size="table.params.count"
          :total="table.total"
          :page-sizes="[10, 20, 50, 100, 150, 300]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :title="type == 1 ? '添加报价' : '修改报价'"
      :visible.sync="dialogFormVisible"
      append-to-body
      width="400px"
      @close="close"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="商品名称">
          <el-select
            v-show="type == 1"
            v-model="form.spec_id"
            filterable
            remote
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="selLoading"
            ref="multiSelect"
            size="small"
            @change="changeGoods(table.params.group_id)"
            value-key="id"
          >
            <el-option
              v-for="item in goodArr"
              :label="item.good_name"
              :value="item.id"
              :key="item.id"
              :disabled="item.sold_out == 1 ? true : false"
            >
              <div class="flex" style="justify-content: space-between">
                <div>
                  <span style="float: left">{{ item.good_name }}</span>
                  <span
                    v-if="item.sold_out == 1"
                    style="color: #f56c6c; font-size: 12px"
                    >(售罄)</span
                  >
                </div>
                <span style="color: #8492a6; font-size: 13px"
                  >{{ item.unit_name }}/{{ item.name }}</span
                >
              </div>
              <div
                style="color: #999; margin-top: -5px"
                v-if="!!item.norm_name"
              >
                标名：{{ item.norm_name }}
              </div>
            </el-option>
          </el-select>
          <div class="fdscx" v-show="type == 2">
            <div class="fdscx">
              {{ goods_name }}
            </div>
            <span class="fedsa"> {{ unit_name }}/{{ name }} </span>
          </div>
        </el-form-item>
        <el-form-item label="" label-width="10px">
          定价方式：{{
            form.price_type ? (form.price_type == 1 ? "线下询价" : "采购价") : ""
          }}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;折扣率：{{
            form.rate ? form.rate + "%" : ""
          }}
        </el-form-item>
        <el-form-item label="参考价">
          <el-input
            size="small"
            v-model.trim="form.amount"
            placeholder="请输入参考价"
            clearable
            ><template slot="append"
              >售价：¥{{
                form.amount && form.rate
                  ? ((form.amount * form.rate) / 100).toFixed(3) * 1
                  : ""
              }}</template
            ></el-input
          >
        </el-form-item>
        <el-form-item label="参考对象" v-show="discount_type == 2">
          <el-input
            size="small"
            v-model="form.object"
            placeholder="请输入参考对象"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="sub">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "PlatformDetail",
  mixins: [mixinTable],
  data() {
    return {
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      visible: false,
      isChange: false,
      table: {
        loading: false,
        params: {
          order_cate_id: "",
          order_cate_tow: "",
          group_id: "",
          goods_name: "",
          price_type: "",
          page: 1,
          count: 20,
        },
        data: [],
        total: 0,
      },
      orderCateArr: [], // 下单分类
      group_name: "",
      dialogFormVisible: false,
      form: {
        spec_id: "",
        group_id: "",
        amount: "",
        object: "",
        rate: "",
        price_type: "",
      },
      goodArr: [], // 商品列表
      selLoading: false,
      discount_type: "",
      type: "",
      goods_name: "",
      unit_name: "",
      name: "",
    };
  },
  methods: {
    getDetail(row) {
      this.table.data = [];
      this.table.params.goods_name = row.goods_name;
      this.group_name = row.group_name;
      this.table.params.group_id = row.group_id;
      this.table.loading = true;
      this.$http
        .get("/admin/group_file/info", {
          params: {
            group_id: row.group_id,
            goods_name: row.goods_name,
          },
        })
        .then((res) => {
          this.table.loading = false;
          if (res.code == 1) {
            this.discount_type = res.discount_type;
            this.table.loading = false;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        });
    },
    getDetail1(row) {
      this.table.params.goods_name = row.goods_name;
      this.group_name = row.group_name;
      this.table.params.group_id = row.group_id;
      this.table.loading = true;
      this.$http
        .get("/admin/group_file/info", {
          params: {
            group_id: row.group_id,
            goods_name: row.goods_name,
          },
        })
        .then((res) => {
          this.table.loading = false;
          if (res.code == 1) {
            this.discount_type = res.discount_type;
            this.table.loading = false;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        });
      this.showEdit(1);
    },
    getTable() {
      this.table.loading = true;
      let _params = { ...this.table.params };
      this.$http
        .get("/admin/group_file/info", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.loading = false;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          }
        });
    },
    reset(done) {
      this.isChange = false;
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 返回
    handleReturn() {
      this.toggle(false);
      this.info = {
        shipping_info: {},
      };
    },
    showEdit(t, row) {
      this.type = t;
      if (t == 2) {
        this.form.spec_id = row.id;
        this.form.group_id = this.table.params.group_id;
        this.form.amount = row.price;
        this.form.price_type = row.price_type;
        this.form.rate = row.rate;
        this.goods_name = row.goods_name;
        this.unit_name = row.unit_name;
        this.name = row.name;
      }
      this.dialogFormVisible = true;
    },
    close() {
      this.form = {
        spec_id: "",
        group_id: "",
        amount: "",
        object: "",
        rate: "",
        price_type: "",
      };
      this.dialogFormVisible = false;
    },
    remoteMethod(query) {
      if (query !== "") {
        let _params = {
          page: 1,
          count: 1000,
          status: 1,
          good_name: query,
        };
        this.selLoading = true;
        this.$http
          .get("/admin/goods/specList", { params: _params })
          .then((res) => {
            if (res.code === 1) {
              this.goodArr = res.data.list;
            }
          })
          .finally(() => {
            this.selLoading = false;
          });
      } else {
        this.goodArr = [];
      }
    },
    changeGoods(group_id) {
      console.log(group_id, this.form.spec_id);
      this.form.group_id = group_id;
      this.$http
        .get("/admin/group_file/getPriceType", {
          params: { spec_id: this.form.spec_id, group_id },
        })
        .then((res) => {
          if (res.code === 1) {
            this.form.rate = res.data.rate;
            this.form.price_type = res.data.price_type;
          }
        });
    },
    sub() {
      if (!this.form.spec_id) {
        this.$message.error("请选择商品");
        return;
      }
      if (!this.form.amount) {
        this.$message.error("请输入参考价");
        return;
      }
      if (!this.form.object && this.discount_type == 2) {
        this.$message.error("请输入参考对象");
        return;
      }
      this.dialogFormVisible = false;
      this.$http
        .post(
          this.type == 1 ? "/admin/group_file/add" : "admin/group_file/edit",
          {
            ...this.form,
          }
        )
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.getTable();
            this.type == 1 && this.$emit("refresh");
          }
        });
    },
    del(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http
            .post("/admin/group_file/delete", {
              spec_id: row.id,
              group_id: this.table.params.group_id,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("删除成功");
                this.getTable();
                this.$emit("refresh");
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.addPerson__wrap {
  @include position($t: 0, $r: 0, $b: 0, $l: 0);
}

.mainBox {
  flex: 1;
  background: #fff;
}
.pagination__wrap {
  background: #fff;
  padding: 10px 60px;
  text-align: right;
  /* padding-right: 40px; */
}
.el-select-dropdown__item {
  display: flex;
  flex-direction: column;
  height: auto !important;
}
.fedsa {
  font-size: 12px;
}
</style>
